import { render, staticRenderFns } from "./PiutangSalesmanNew.vue?vue&type=template&id=1da12f2c&scoped=true"
import script from "./PiutangSalesmanNew.vue?vue&type=script&lang=js"
export * from "./PiutangSalesmanNew.vue?vue&type=script&lang=js"
import style0 from "./PiutangSalesmanNew.vue?vue&type=style&index=0&id=1da12f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da12f2c",
  null
  
)

export default component.exports